/**
 * Handles the load more and filter functionality for organisations
 */
import getAjaxContent from './util/get-ajax-content';
import updateFilters from './util/update-filters';
import deleteCardAnimation from './util/delete-card-animation';
import buildModal from './util/build-modal';

(() => {
	class Handler {
		constructor(sector, sectorClass) {
			const rootEl = sector;
			const $filters = rootEl.querySelectorAll(
				'li.organisation-filters__list-item'
			);
			const filterActive = 'organisation-filters__list-item--active';
			const $mobileHeader = rootEl.querySelector(
				'div.organisation-filters___mobile-header'
			);
			const $loadMoreButton = rootEl.querySelector(
				'.load-more-button__button'
			);
			const searchInputActiveClass =
				'organisation-search__input-wrap--active';
			const $searchInputWrapper = rootEl.querySelectorAll(
				'div.organisation-search__input-wrap'
			);
			const $searchForm = rootEl.querySelectorAll(
				'div.organisation-search__form'
			);
			let searchTerm;
			const $searchBtn = rootEl.querySelector(
				'button.organisation-search__button'
			);
			const $cards = rootEl.querySelectorAll('div.organisation-card');
			const timeout = 1200;
			// Global settings with used within fetch body and past to getAjaxContent
			const globalSettings = {
				action: 'load_more_content',
				// eslint-disable-next-line no-undef
				nonce: ajax_params.ajaxNonce,
				paged: 1, // Which page of results to return
				template: 'organisation-card', // Which template to load. template_parts/cards/search-result-card.php
				card: 'organisation-card',
				taxonomy: 'organisation_type',
				searchTerm: '',
				//taxonomyTerms: [], // Array of user selected taxonomy  ids
				rootEl,
			};
			// Clone the global settings to new objects;
			const settings = Object.assign({}, globalSettings);
			const featuredSettings = Object.assign({}, globalSettings);

			if (
				rootEl instanceof window.HTMLElement &&
				$cards[0] instanceof window.HTMLElement
			) {
				// eslint-disable-next-line no-undef

				settings.query = organizationsMyAjax; // Search query
				// eslint-disable-next-line no-undef
				settings.maxPage = organizationsMaxPageMyAjax; // Total number of page results
				settings.insert = '.organisations-grid__insert';

				/**
				 * Load more click event
				 * This function is responsible getting new content by calling getAjaxContent
				 */
				if ($loadMoreButton instanceof window.HTMLElement) {
					$loadMoreButton.addEventListener('click', () => {
						settings.paged++; // Updates page so that the next page of the current results can be loaded
						settings.btn = 'load-more';

						//getAjaxContent(settings, $loadMoreButton);
						reRenderContent(settings.paged, false);
					});
				}
				/**
				 * Filters
				 * This function is responsible for getting the category id from the frontend
				 */
				$filters.forEach((el) => {
					el.addEventListener('click', function () {
						let id = el.dataset.id
						let searchParams = new URLSearchParams(window.location.search)
						searchParams.set('term', id)

						history.replaceState(null, null, "?" + searchParams.toString());
						setActiveFilter(el)
					});
				});
			}
			/**
			 * This is responsible for the text overlay on the search input
			 */
			$searchInputWrapper.forEach((el) => {
				const $searchInput = el.querySelector('input[type="search"]');
				el.addEventListener('mouseover', function () {
					el.classList.add(searchInputActiveClass);
				});
				el.addEventListener('mouseout', function () {
					if (
						$searchInput.value.length === 0 &&
						// eslint-disable-next-line @wordpress/no-global-active-element
						$searchInput !== document.activeElement
					) {
						el.classList.remove(searchInputActiveClass);
						settings.searchTerm = '';
						featuredSettings.searchTerm = '';
					}
				});
				$searchInput.addEventListener('blur', function () {
					if (this.value.length === 0) {
						el.classList.remove(searchInputActiveClass);
					}
				});
			});

			/**
			 * This adds an active class to the clear search button
			 */
			$searchForm.forEach((el) => {
				const $searchInput = el.querySelector('input[type="search"]');
				const $searchClear = el.querySelector(
					'.organisation-search__clear'
				);
				const $searchInputWrapper = el.querySelector(
					'.organisation-search__input-wrap'
				);
				const searchClearActiveClass =
					'organisation-search__clear--active';

				$searchInput.addEventListener('input', function () {
					$searchClear.classList.add(searchClearActiveClass);
				});
				$searchClear.addEventListener('click', function () {
					// Reset query
					$searchInput.value = '';
					settings.searchTerm = '';
					featuredSettings.searchTerm = '';

					// Hide clear button
					$searchClear.classList.remove(searchClearActiveClass);
					reRenderContent();

					// Remove active class from form wrapper
					$searchInputWrapper.classList.remove(
						searchInputActiveClass
					);
				});
			});

			/**
			 * This functionality is responsible for getting the search term and passing it to the Ajax function.
			 */
			if ($searchBtn instanceof window.HTMLElement) {
				$searchBtn.addEventListener('click', (e) => {
					e.preventDefault();
					searchTerm = $searchBtn.parentNode.querySelector(
						'.organisation-search__input'
					).value;

					if (searchTerm.length !== 0) {
						settings.searchTerm = searchTerm;
						featuredSettings.searchTerm = searchTerm;
						reRenderContent();
					}
				});
			}
			/**
			 * This functionality is responsible for mobile filter dropdown
			 */
			if ($mobileHeader instanceof window.HTMLElement) {
				$mobileHeader.addEventListener('click', (e) => {
					e.preventDefault();
					$mobileHeader.parentElement.classList.toggle(
						'organisation-filters__wrap--active'
					);
				});
			}
			/**
			 * This functionality is responsible for displaying the organisation modal by passing a post id
			 */
			document
				.querySelector('body')
				.addEventListener('click', (event) => {
					const card = event.target.closest('.organisation-card');
					if (card) {
						buildModal({
							postID: parseInt(card.dataset.id, 10),
							postType: 'organisation',
						});
					}
				});

			/**
			 * Updates the mobile filters
			 * This functionality is responsible for updating organisation mobile filters
			 *
			 *
			 * @param { string } text
			 */
			const updateMobileFilters = (text) => {
				const label = document.querySelector(
					'span.organisation-filters___mobile-header-text'
				);
				if (label instanceof window.HTMLElement) {
					label.textContent = text;
				}
				if ($mobileHeader instanceof window.HTMLElement) {
					$mobileHeader.parentElement.classList.toggle(
						'organisation-filters__wrap--active'
					);
				}
			};

			// This functionality is responsible for deleting the current cards and getting new content
			const reRenderContent = (page = 1, deleteCards = true) => {
				// Sets page to 1 so that it gets the first page of the filtered results.
				settings.paged = page;

				// Removes current organisations
				if (deleteCards) {
					deleteCardAnimation(
						rootEl.querySelectorAll('div.' + settings.card),
						timeout
					);
				}
				// Waits for the deleteCardAnimation function to finish before getting the new results
				setTimeout(function () {
					/**
					 * This functionality is responsible for getting featured content
					 */

					const $featured = rootEl.querySelector(
						'.organisations-grid__insert--featured'
					);

					if ($featured instanceof window.HTMLElement) {
						// eslint-disable-next-line no-undef
						featuredSettings.query = organizationsMyAjaxFeatured;
						featuredSettings.maxPage =
							// eslint-disable-next-line no-undef
							organizationsMaxPageMyAjaxFeatured;
						featuredSettings.featured = true;
						featuredSettings.insert =
							'.organisations-grid__insert--featured';
						featuredSettings.paged = page;

						settings.featuredSettings =
							JSON.stringify(featuredSettings);
					}

					getAjaxContent(settings, $loadMoreButton);
				}, timeout);
			};

			const setActiveFilter = (el) => {
				//Updates the state of the filters
				updateFilters(el, filterActive);
				//Removes the current taxonomy ID from the settings array
				if (el.dataset.id !== 'all') {
					settings.taxonomyTerms = [];
					featuredSettings.taxonomyTerms = [];
					//Adds taxonomy ID to the settings array
					settings.taxonomyTerms.push(el.dataset.id);
					featuredSettings.taxonomyTerms.push(el.dataset.id);
				} else {
					settings.taxonomyTerms = [];
					featuredSettings.taxonomyTerms = [];
				}

				//Set btn class name
				settings.btn = 'filter';
				
				reRenderContent();
				updateMobileFilters(
					el.querySelector('span').textContent
				);
			}

			/**
			 * Pre defined Filter
			 * This function is responsible for getting a term that is set in the URL an applying it as a filter
			 */
			const urlParams = new URLSearchParams(window.location.search);
			const term = urlParams.get('term');
			if(term) {
				$filters.forEach((el) => {
					if(Number(el.dataset.id) === Number(term)) {
						setActiveFilter(el)
					}
				})
			}
		}
	}

	// Init a handler for each block instance
	const sectorClass = 'organisations';
	const sectors = Array.from(
		document.querySelectorAll(`section.${sectorClass}`)
	);
	sectors.forEach((o) => new Handler(o, sectorClass));
})();
